import { useParams } from "react-router-dom";
import { useGetInvoicePdfQuery } from "../../withdrawal-requests.service";
import PageHeader from "src/components/pageHeader";
import PageLoading from "src/components/pageLoading";
const Invoice = () => {
  let { id = "" } = useParams();
  const { isError, isSuccess, data } = useGetInvoicePdfQuery(id, { skip: !id });
  return isSuccess ? (
    <div className="page_container">
      <PageHeader text="Invoice" />
      <embed src={data.invoice} type="application/pdf" width="100%" height="600px" />
    </div>
  ) : isError ? (
    <p className="alert alert-danger">Error fetching invoice</p>
  ) : (
    // <Navigate to={`/withdrawal-requests/${id}`} />
    <PageLoading />
  );
};

export default Invoice;
